/**
 * Handles the JavaScript associated with the Section navigation
 */
import scrollEvent from '../../components/fsUtils/scrollEvent';
import screenLock from '../../components/fsUtils/screenLock';
import Viewports from "../../components/fsUtils/Viewports";

var forEach = function(array, callback, scope) {
    for (var i = 0; i < array.length; i++) {
        callback.call(scope, i, array[i]); // passes back stuff we need
    }
}

class NavSection {
    constructor() {
        this.bodyTag = document.body || document.getElementsByTagName('body')[0];
        this.isPage = this.bodyTag.classList.contains('single-page');
        this.isCustomPage = this.isPage && document.querySelector('link[id*=custom-style]:not([href*="/empty/"])');
        this.subNav = document.querySelectorAll('.section-nav .top-level .sub-menu');
        this.subNavBackHtml = '<span class="sub-menu-back">Back</span>';
        this.moreOverflow = document.querySelector('.section-more');
        this.sectionNav = document.querySelector('.section-nav');
        this.throttle = ('ontouchstart' in document.documentElement) ? 100 : 10;
        this.topLevel = document.querySelector('.section-nav .top-level');
        this.sectionNavChildCount = this.topLevel.childElementCount;
        this.sectionNavChildren = this.topLevel.children;
        this.mActivator = document.querySelector('.m-nav-activator');
        this.globalNav = document.querySelector('.global-nav-container');
        this.globalNavHeight = this.globalNav.offsetHeight;
        this.header = document.getElementById('js-body-header');
        this.screenLock = new screenLock();
        this.branchBannerHeight = (this.isCustomPage) ? 0 : 76;
        this.viewport = new Viewports({
            'mobile': 767,
            'tablet': 768,
            'desktop': 1025
        });        
        if ( this.viewport.isIOSSafari && !this.bodyTag.classList.contains('ios-safari') ) { this.bodyTag.classList.add('ios-safari'); }

        this.viewport = this.viewport.getViewPort();

        // Let the CSS know we have touch available
        if ('ontouchstart' in window || navigator.maxTouchPoints) {
            document.documentElement.className += " has-touch";
        } else {
            document.documentElement.className += " no-touch";
        }

        // Set up the initial team menu state before any page-level evaluation happens
        this.removeTeamDropdownMenu();

        // Set up the watch menus
        this.navWatchTitleLink();

        /**
         * Hides the "More" navigation item until it has been determined to be
         * either empty or populated in order to prevent the user from seeing it
         * in an unfinished state.
         */
        this.moreOverflow.style.display = 'none';

        this.mActivator.addEventListener('click', (e) => this.mobileNavToggle(e));

        // uncomment when when resume sec nav pinning
        // bind "pin on scroll"
        // this.navSticker = this.navSticker.bind(this);
        // this.navSticker = scrollEvent.throttle(this.navSticker, this.throttle);
        // window.addEventListener('scroll', this.navSticker);
        document.addEventListener('DOMContentLoaded', () => this.moreMenuBuilder());
        document.addEventListener('DOMContentLoaded', () => this.moveTeamDisplayMenu());
        document.addEventListener('DOMContentLoaded', () => this.buildTeamSlider());
        document.addEventListener('DOMContentLoaded', () => this.navMenuHandler());


        window.addEventListener('resize', () => {
            scrollEvent.debounce(100, this.moveTeamDisplayMenu());
        });

        this.handleSubNavBack();

    }

    handleSubNavBack() {
        // Add the HTML pertaining to the "Back" button on mobile sub-navigation menus.
        let subNavBackHtml = this.subNavBackHtml;
        forEach(this.subNav, function(index, value) {
            let subNavLocal = value.querySelector('li:first-of-type');
            subNavLocal.insertAdjacentHTML('beforebegin', subNavBackHtml);
        });

        // Define subNavBack after it has been inserted by the JS
        let subNavBack = document.querySelectorAll('.section-nav .sub-menu .sub-menu-back');

        // For each subNavBack, remove active class on click.
        forEach(subNavBack, function(index, value) {
            let subNavBackParent = value.parentNode.parentNode;
            value.addEventListener('click', function() {
                if (subNavBackParent.classList.contains('is-active')) {
                    subNavBackParent.classList.remove('is-active');
                }
            });
        });
    }


    /**
     * Function to handle second nav dropdowns
     */
    navMenuHandler() {
        //get nav parents when more menu is build
        let subNavParents = document.querySelectorAll('.section-nav ul > ul > li.menu-item-has-children > a');
        let viewport = this.viewport;
        forEach(subNavParents, function(index, value) {
            var subNavAnchor = value;
            var subNavLi = value.parentNode;
            /**
             * Detect wether the sub navigation should be opened on hover or click
             * depending on screen size.
             */
            function hoverDetector() {
                if ('desktop' === viewport) {
                    subNavLi.classList.add('hover');
                } else {
                    subNavLi.classList.remove('hover');
                    subNavAnchor.addEventListener('click', (e) => activeListener(e));
                }
            }

            /**
             * Function to handle when the sub-navigation should appear on click.
             */
            function activeListener(e) {
                e.preventDefault();
                if ("More" !== e.target.innerText && 'mobile' !== viewport) {
                    window.open(e.target.href, "_self");
                }
                var subNavParentsActive = document.querySelectorAll('.section-nav ul > ul > li.menu-item-has-children.is-active');
                if (subNavLi.classList.contains('is-active') && !subNavLi.classList.contains('hover')) {
                    subNavLi.classList.remove('is-active');

                } else if (subNavLi.classList.contains('is-active') && subNavLi.classList.contains('hover')) {
                    subNavLi.classList.remove('is-active');
                    subNavLi.classList.remove('hover');
                } else {
                    forEach(subNavParentsActive, function(index, value) {
                        value.classList.remove('is-active')
                    });
                    subNavLi.classList.add('is-active');
                }
            }
            hoverDetector();

        });
    }

    /**
     * Function to toggle classes for the mobile navigation.
     */
    mobileNavToggle(e) {
            e.preventDefault();
            this.mActivator.classList.toggle('is-active');
            this.topLevel.classList.toggle('is-active');
            document.body.classList.toggle('section-menu-open');
            if (document.body.classList.contains('section-menu-open')) {
                if (document.body.classList.contains('branch-banner-is-active') && window.pageYOffset <= this.branchBannerHeight) {
                    window.scrollTo(0, this.branchBannerHeight);
                }
                this.screenLock.lockScreen();
            } else {
                this.screenLock.unlockScreen();
            }
        }
        // uncomment when when resume sec nav pinning
        // /**
        //  * Stick the section navigation to the top as the user scrolls down.
        //  * Accounts for logged in users as well as logged out.
        //  */
        // navSticker() {
        // 	var scrollTimeout;
        // 	// ignore scroll events as long as an actualResizeHandler execution is in the queue
        // 	if (!scrollTimeout) {
        // 		scrollTimeout = setTimeout(function() {
        // 			scrollTimeout = null;

    // 			var wpAdmin = document.getElementById('wpadminbar');
    // 			this.sectionNav = document.querySelector('.section-nav'),
    // 				this.globalNav = document.querySelector('.global-nav-container'),
    // 				this.globalNavHeight = this.globalNav.offsetHeight;

    // 			if (null !== wpAdmin) {
    // 				var wpAdminHeight = wpAdmin.offsetHeight;
    // 			}

    // 			if (this.globalNavHeight <= window.pageYOffset && wpAdmin === null) {
    // 				this.sectionNav.classList.add('fixed');
    // 				if (null !== wpAdmin) {
    // 					this.sectionNav.style.top = wpAdminHeight + 'px';
    // 				} else {
    // 					this.sectionNav.style.top = '0';
    // 				}
    // 			} else if (this.globalNavHeight + wpAdminHeight <= window.pageYOffset + wpAdminHeight) {
    // 				this.sectionNav.classList.add('fixed');
    // 				if (null !== wpAdmin) {
    // 					this.sectionNav.style.top = wpAdminHeight + 'px';
    // 				} else {
    // 					this.sectionNav.style.top = '0';
    // 				}
    // 			} else {
    // 				this.sectionNav.classList.remove('fixed');
    // 				this.sectionNav.style.top = null;
    // 			}
    // 			// The actualResizeHandler will execute at a rate of 15fps
    // 		}, 66);
    // 	}
    // }

    /**
     * Build the more navigation based on space available in the top menu
     */
    moreMenuBuilder() {
        const sectionNavMore = document.querySelector(' .section-more ');
        const sectionNavMoreSub = document.querySelector('.section-more .sub-menu');
        const menu = document.querySelector('.section-nav-wrap .menu');
        const topMenu = menu.querySelector('.top-level');
        var self = this;

        this.buildMoreMenu(menu, sectionNavMore, sectionNavMoreSub);

        // add scroll buttons to teams menu
        this.addClickScrollToTeamsMenu();

        window.addEventListener('resize', () => {
            scrollEvent.debounce(100, self.resetAndBuild(menu, topMenu, sectionNavMore, sectionNavMoreSub));

            // add scroll buttons to teams menu
            scrollEvent.debounce(100, self.addClickScrollToTeamsMenu);
        });

    }

    resetAndBuild(menu, topMenu, moreLink, moreMenu) {
        // Reset more menu and recount items that fit in the menu
        this.resetMoreMenu(moreLink, topMenu, menu);
        this.buildMoreMenu(menu, moreLink, moreMenu);
    }

    /**
     * Helper method to add multiple attribute to an element at once
     */
    setAttributes(el, attrs) {
        for (var key in attrs) {
            el.setAttribute(key, attrs[key]);
        }
    }

    /**
     * Clone the "Tune In" menu item for The Herd and stick it above the content area on small screen
     */
    cloneTuneInMenu(menuTuneIn) {

            var menuTuneInContent = menuTuneIn.innerHTML;
            var bodyContent = document.querySelector('.body-content');
            var bannerAdContainer = document.querySelector('.banner-ad-container');
            var holderParentElement;

            // if bodyContent and bannerAdContainer are not on the page, fail silently
            if (!bodyContent && !bannerAdContainer) {
                return;
            }

            // if bodyContent exists, but bannerAdContainer doesn't, move forward with bodyContent
            if (bodyContent && !bannerAdContainer) {
                holderParentElement = bodyContent.parentNode;
            }

            var viewports = new Viewports();

            // Create a target element to move .menu-tune-in contents on small screen
            var cloneTarget = document.createElement('div');
            var cloneCatcher = document.createElement('div');

            // Setting up this area to revieve content for viewing and assitive technology
            this.setAttributes(cloneTarget, {
                'class': 'menu-tune-in__clone',
                'id': 'menu-tune-in__clone',
                'aria-live': 'polite',
                'aria-atomic': 'true',
                'aria-relvent': 'additions removals'
            });

            // Create an area to catch the content
            this.setAttributes(cloneCatcher, {
                'class': 'menu-tune-in',
                'id': 'menu-tune-in__catcher'
            });

            // Combine the two elements
            cloneTarget.appendChild(cloneCatcher);

            // making sure this only runs once
            if (!document.getElementById('menu-tune-in__clone')) {

                // if bannerAdContainer exists, use it, otherwise check for bodyContent
                if (bannerAdContainer) {
                    bannerAdContainer.parentNode.insertBefore(cloneTarget, bannerAdContainer.nextSibling);
                } else if (bodyContent) {
                    holderParentElement.insertBefore(cloneTarget, bodyContent);
                }


            } // check for clone in the DOM

            // Add the cloned content into the catcher if on small screen
            if ('mobile' === viewports.getViewPort(this.winW)) {

                // Hide the menu LI from view and assitive technology
                menuTuneIn.style.display = 'none';
                menuTuneIn.setAttribute('aria-hidden', 'true');

                // Add the new item into the DOM
                document.getElementById('menu-tune-in__clone').setAttribute('aria-hidden', 'false');
                document.getElementById('menu-tune-in__catcher').innerHTML = menuTuneInContent;

            } else {

                // Show the original menu item LI
                menuTuneIn.removeAttribute('style');
                menuTuneIn.setAttribute('aria-hidden', 'false');

                // Remove this item from the DOM
                document.getElementById('menu-tune-in__clone').setAttribute('aria-hidden', 'true');
                document.getElementById('menu-tune-in__catcher').innerHTML = '';

            }

        } // this.cloneTuneInMenu();

    buildMoreMenu(menu, moreLink, moreMenu) {
            const wrapper = document.querySelector('.section-nav-wrap');
            const isworldcupnav = wrapper.parentElement.classList.contains( 'soccer-world-cup-nav' );
            const menuTuneIn = document.querySelector('.menu-tune-in');
            const menuTopLevelItems = menu.querySelectorAll('.top-level > li.menu-item');
            const menuTitle = menu.querySelector('.menu-title');
            const menuTopLevelItemsCount = menuTopLevelItems.length - 1; // Remove the placeholder More top level item

            let fragment = document.createDocumentFragment();

            var viewports = new Viewports();
            var menuTitleWidth = menuTitle.offsetWidth;

            // The title is full width on a different line in those menus
            if (menu.parentNode.parentNode.classList.contains('team-nav') || menu.parentNode.parentNode.classList.contains('watch-nav')) {
                menuTitleWidth = 0;
            }
            var wrapperStyles = getComputedStyle(wrapper);
            var wrapperWidth = parseInt(wrapperStyles.width, 10) - parseInt(wrapperStyles.paddingLeft, 10) - parseInt(wrapperStyles.paddingRight, 10) - menuTitleWidth;
            var menuWidth = parseInt(wrapperWidth - 300, 10); // Allow us a 300px gap to fit eventual More link
            var moreSubItems = 0;
            var tempWidth = 0;
            var breakIndex = 0;
            var i = 0;

            if ( menuTuneIn ) {

                menuWidth = menuWidth - menuTuneIn.offsetWidth;

                if( !isworldcupnav ) this.cloneTuneInMenu(menuTuneIn);

            }

            // Loop through menu top level items and add up their width
            // Stop while the added widths are smaller than the available space
            do {
                breakIndex = i;
                tempWidth += menuTopLevelItems[i].offsetWidth;
                i++;
            } while (tempWidth < menuWidth && i <= menuTopLevelItemsCount);

            // On small screens, we want exactly 10 links, counting More link
            if ('mobile' === viewports.getViewPort(this.winW)) {
                breakIndex = 9;
            }

            // Count how many submenu items we are left with
            moreSubItems = menuTopLevelItemsCount - breakIndex;

            // Move items that don't fit in the More submenu if there is more than one
            // Display more link
            if (breakIndex < menuTopLevelItemsCount && moreSubItems > 1) {

                for (var j = breakIndex; j < menuTopLevelItemsCount; j++) {

                    moreMenu.appendChild(menuTopLevelItems[j]);

                } // for

                // remove the style attribute instead of setting the inline CSS
                moreLink.removeAttribute('style');

            } // if

            // Menu checks done, add class loaded
            menu.classList.add('loaded');

        } // buildMoreMenu()

    resetMoreMenu(moreMenu, topMenu, menu) {

            const menuTuneIn = document.querySelector('.menu-tune-in');
            var moreSubMenu = moreMenu.querySelector('.sub-menu');
            var moreMenuItems = moreSubMenu.childNodes;

            // If the moreMenuItems container doesn't exist, bail out
            if (!moreMenuItems) {
                return;
            }

            var moreMenuItemsCount = moreMenuItems.length;
            var separatorItem = moreMenu;
            var i;

            // If menu tune in is present, insert items before the tune in <li>
            if (menuTuneIn) {
                separatorItem = menuTuneIn;
            }

            // For each item in More submenu, add it back to the top menu
            if (moreMenuItemsCount >= 0) {
                for (i = 0; i < moreMenuItemsCount; i++) {

                    // I need this because there's a SPAN in the UL that needs to stay there
                    if (moreMenuItems[i] && moreMenuItems[i].nodeName === 'LI' && moreMenuItems[i].innerHTML !== '') {
                        topMenu.insertBefore(moreMenuItems[i], separatorItem);
                    }
                }
            }

            // Hide the more link
            moreMenu.style.display = 'none';

            // Failsafe check to see if there are any items in the menu, if so, show it.
            if (moreMenu.querySelectorAll('.menu-item').length !== 0) {
                moreMenu.removeAttribute('style');
            }

            // Restore menu class
            menu.classList.remove('loaded');

        } // resetMoreMenu()

    /**
     * Move team display menu in small screen
     */
    moveTeamDisplayMenu() {
        const teamDisplayMenu = document.querySelector('.local-team-display--wrapper');
        var viewports = new Viewports();

        // if the teamDisplayMenu doesn't exist, don't bother
        if (!teamDisplayMenu) {
            return;
        }

        if ('mobile' === viewports.getViewPort()) {
            // Move team display menu to top of top-level menu on small screen
            if (!this.topLevel.querySelector('.local-team-display--wrapper')) {
                this.topLevel.insertBefore(teamDisplayMenu, this.topLevel.firstChild);
            }
        } else {
            document.querySelector('.section-nav-wrap > ul').appendChild(teamDisplayMenu);
        }
    }

    /**
     * Get the total width of an object
     */
    getTotalWidth(obj) {

        if (!obj) {
            return;
        }

        var style = obj.currentStyle || window.getComputedStyle(obj);
        var objWidth = obj.offsetWidth; // includes padding
        var objMargin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);
        var objBorder = parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);
        var totalObjWidth = objWidth + objMargin + objBorder;

        return totalObjWidth;

    }

    /**
     * Add click scrolling to team menu
     */
    addClickScrollToTeamsMenu() {

        // Setting and caching some variables
        var teamMenuWrapper = document.querySelector('.local-team-display--wrapper');

        // if the teamMenuWrapper isn't there, bail out
        if (!teamMenuWrapper) {
            return;
        }

        var teamMenu = document.querySelector('.local-team-display');
        var teamMenuWidth = this.getTotalWidth(teamMenu);
        var teamMenuItems = teamMenu.querySelectorAll('.menu-item');
        var teamMenuItemCount = teamMenuItems.length;
        var teamMenuTotalWidth = 0;
        var i;
        var obj;
        var objWidthCalc;

        // Loop through all the menu items to calculate the width needed to display without a scrollbar
        for (i = 0; i < teamMenuItemCount; i = i + 1) {
            obj = teamMenuItems[i];
            objWidthCalc = this.getTotalWidth(obj);

            // Get the total width of the menu
            teamMenuTotalWidth = teamMenuTotalWidth + objWidthCalc;
        }

        // Check to make sure the content area is scrollable
        if (teamMenuTotalWidth >= teamMenuWidth) {
            teamMenuWrapper.classList.add('has-overflow');
        } else {
            teamMenuWrapper.classList.remove('has-overflow');
        }

    }

    /**
     * Build out the team slider menu, if it exists
     */
    buildTeamSlider() {

            var teamMenuWrapper = document.querySelector('.local-team-display--wrapper');
            var teamMenu = document.querySelector('.local-team-display');

            // If there's no teamMenuWrapper, bail out
            if (!teamMenuWrapper) {
                return;
            }

            // Prep the UI for scroll buttons
            var prev = document.createElement('button');
            var next = document.createElement('button');

            // Add a body class to help with the extra height
            document.body.classList.add('contains-team-display-menu');

            // Build out the previous button
            prev.setAttribute('type', 'button');
            prev.setAttribute('aria-hidden', 'true'); // a screen reader can read the list items with out the control
            prev.setAttribute('class', 'btn-prev');
            prev.setAttribute('id', 'btn-prev');
            prev.innerHTML = 'Previous';

            // Build out the next button
            next.setAttribute('type', 'button');
            next.setAttribute('aria-hidden', 'true'); // a screen reader can read the list items with out the control
            next.setAttribute('class', 'btn-next');
            next.setAttribute('id', 'btn-next');
            next.innerHTML = 'Next';

            // The next button into the UI (once)
            if (!document.getElementById('btn-next')) {
                teamMenuWrapper.appendChild(next);
            }

            // Add the previous button into the UI (once)
            if (!document.getElementById('btn-prev')) {
                teamMenuWrapper.insertBefore(prev, teamMenuWrapper.firstChild);
            }

            // Event binding for "previous/scroll" button
            document.getElementById('btn-prev').addEventListener('click', function() {

                // scroll the div
                teamMenu.scrollLeft = 0; // scroll to 0 position

                // Let the CSS know what's going on
                teamMenuWrapper.classList.add('scrolled-to-the-left');
                teamMenuWrapper.classList.remove('scrolled-to-the-right');

            });

            // Event binding for "next/scroll" button
            document.getElementById('btn-next').addEventListener('click', function() {

                // scroll the div
                teamMenu.scrollLeft = 1000; // scroll to the end

                // Let the CSS know what's going on
                teamMenuWrapper.classList.add('scrolled-to-the-right');
                teamMenuWrapper.classList.remove('scrolled-to-the-left');

            });

        } // buildTeamSlider()

    /**
     * Modify the team-based navigation if we can/need to
     */
    removeTeamDropdownMenu() {

            // Get the container nav container when it is telling us the team display is present
            var teamDisplayFlag = document.querySelector('.has-team-display');

            // Cache these variable for later use
            var teamDropdropMenu;
            var localTeamDisplay;

            // If the team display flag is in the UI, move forward
            if (teamDisplayFlag) {

                // Get the team dropdown menu by className
                teamDropdropMenu = teamDisplayFlag.querySelector('.narrow-team');
                localTeamDisplay = teamDisplayFlag.querySelector('.local-team-display');

                // Check to make sure the larger team display exists before removing the dropdown menu
                if (localTeamDisplay) {

                    // Make sure the menu is here before I try to remove it
                    if (teamDropdropMenu) {

                        // Remove the menu item, because we're using a larger version of it elsewhere in the UI
                        teamDropdropMenu.parentNode.removeChild(teamDropdropMenu);

                    }

                } else {

                    // If for some reason the container is telling us the larger menu should be there, but it isn't, remove the class so the UI doesn't break
                    teamDisplayFlag.classList.remove('has-team-display');

                } // teamDropdropMenu && localTeamDisplay

            } // if teamDisplayFlag

        } // removeTeamDropdownMenu()

    /**
     * Make the navigation title of a watch template a link
     */
    navWatchTitleLink() {

            var watchNav = document.querySelector('.watch-nav');

            // If the watchNav isn't available, bail out.
            if (!watchNav) {
                return;
            }

            // Gather some variables to work with
            var watchNavTitle = watchNav.querySelector('.menu-title'); // scope down to the watch navigation menu
            var watchNavTitleSpan = watchNavTitle.querySelector('span'); // get the span inside the navTitle
            var watchNavTitleSpanText = watchNavTitleSpan.innerHTML; // Get the span text, so we can rebuild the link later
            var topLevelNavigation = watchNav.querySelector('.top-level'); // scope down the the toplevel nav object
            var firstLink = topLevelNavigation.querySelectorAll('a')[0]; // get the anchor
            var firstLinkHref = firstLink.getAttribute('href'); // get the href
            var firstLinkTitle = firstLink.getAttribute('title'); // get the href
            var firstLinkText = firstLink.text; // get the anchor text
            var firstLinkTextLowercase = firstLinkText.toLowerCase(); // make the word lowercase
            var firstLinkTextClean = firstLinkTextLowercase.replace(/ /g, ''); // remove all whitespace

            // Get the menu Logo link
            var menuLogoLink = watchNav.querySelector('.menu-logo-overlay');

            // Create a new link that will be inserted into the DOM
            var newHomeLink = document.createElement('a');

            // Make sure the link is labeled as "home"
            if (firstLinkTextClean === 'home') {

                if (menuLogoLink) {
                    // Set properties of the logo overlay
                    menuLogoLink.setAttribute('href', firstLinkHref);
                    menuLogoLink.setAttribute('title', firstLinkTitle);
                }

                // Build out the link
                newHomeLink.setAttribute('href', firstLinkHref);

                // Add a title attr if it exists, otherwise don't worry about it
                if (firstLinkTitle) {
                    newHomeLink.setAttribute('title', firstLinkTitle);
                }

                // Set the link text
                newHomeLink.innerHTML = watchNavTitleSpanText;

                // Make sure the span is in the DOM (it isn't sometimes) before adding this link into the DOM
                if (watchNavTitleSpan) {

                    // Clear out the span
                    watchNavTitleSpan.innerHTML = '';

                    // Put the new link in
                    watchNavTitleSpan.appendChild(newHomeLink);

                } else {

                    // Clear out the heading
                    watchNavTitle.innerHTML = '';

                    // Put the new link link
                    watchNavTitle.appendChild(newHomeLink);

                } // if span

            } // if "home"

        } // navWatchTitleLink()

}

export default NavSection;


// WEBPACK FOOTER //
// ./assets/components/navSection/navSection.js